import { render, staticRenderFns } from "./RankingPanel.vue?vue&type=template&id=5a34f152&"
import script from "./RankingPanel.vue?vue&type=script&lang=js&"
export * from "./RankingPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports